<template>
    <div :class="{ list__open: isOpen }">
        <button type="button"
            class="btn btn-primary font-weight-bold px-4 py-2 mb-3 btn__rounded dropdown-toggle d-md-none"
            @click="isOpen = !isOpen">
            {{ routeLabel }}
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            routeLabel: {
                required: true,
                TYPE: String
            }
        },

        data() {
            return {
                isOpen : false,
                display: ''
            }
        },

        created() {
            window.addEventListener('resize', this.onResize);
            this.onResize();
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },

        watch: {
            routeLabel() {
                if (this.display < 768) {
                    this.isOpen = !this.isOpen;
                }
            }
        },

        methods: {
            onResize() {
                this.display = window.innerWidth;
            },
        }
    }
</script>
